// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: '#7A0C2E',
  backgroundColor: '#FFE7D9',
}));
// ----------------------------------------------------------------------

export default function Average(props) {
  const { prodInfo, title } = props;
  const notSold = prodInfo && prodInfo.nprod ? prodInfo.nprod.length : 0;
  return (
    <RootStyle style={{ borderRadius: '16px', fontFamily: 'Public Sans, sans-serif' }}>
      <Typography variant="h3">{fShortenNumber(notSold)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title ? title : 'Products Not Sold'}
      </Typography>
    </RootStyle>
  );
}
